module.exports = __webpack_public_path__ + "static/img/nBig.e1cea7ad.jpg";